export default interface ShiftInfo {
    unassignedPositions: number;
    totalSites: number;
    totalAgencies: number;
    totalInspectors: number;
    totalOnSite: number;
    totalConfirmed: number;
}

// Pick allows you to select some properties from the type you intend to use
// For more info, visit https://www.typescriptlang.org/docs/handbook/utility-types.html#picktype-keys
export type TotalShiftPositions = Pick<ShiftInfo, 'unassignedPositions' | 'totalAgencies' | 'totalInspectors'>;

export const getShiftPriorityOrder = (shiftName: string): number => {
    switch (shiftName) {
        case 'MIDNIGHT': return 1;
        case 'DAY': return 2;
        case 'AFTERNOON': return 3;
        case '3RD': return 4;
        case '1ST': return 5;
        case '2ND': return 6;
        case '4TH': return 7;
        case '5TH': return 8;
        case 'A SHIFT': return 9;
        case 'B SHIFT': return 10;
        case 'C SHIFT': return 11;
        case 'D SHIFT': return 12;
        default: return 0;
    }
};
